import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import logo from './img/uact-logo.png';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import ukraine_icon from './img/ukraine.png'
import ireland_icon from './img/ireland.png'
import { useContext } from './Context.js';

const LOCALE_FLAG_MAPPING = {
  en: ireland_icon,
  ua: ukraine_icon
}

export function ToggleLanguage() {
  const { t, i18n: {changeLanguage, language} } = useTranslation();
  const {locale: {currentLanguage, setCurrentLanguage}} = useContext()
  const newLanguage = currentLanguage === "ua" ? "en" : "ua";

  const handleChangeLanguage = () => {
    setCurrentLanguage(newLanguage);
    changeLanguage(newLanguage);
  }
  useEffect(()=>{
    setCurrentLanguage(language)
  }, [])
  return currentLanguage && (
    <>
      <div onClick={handleChangeLanguage}>{newLanguage.slice(0,2).toUpperCase()}
        <img src={LOCALE_FLAG_MAPPING[newLanguage.slice(0,2)]} alt={newLanguage.slice(0,2)} 
            style={{width:'32px', height: '32px'}}></img>
      </div>
    </>
  ) || <></>
}


function UACTNavbar() {
  const { t} = useTranslation();

  return (
    <>
      <Navbar fixed={'top'} className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="#">
            <div
            style={{margin: "16px 4px 16px 16px",float: 'left', overflow: 'hidden', width: '32px'}}
             >

              <img
                alt="uact-logo"
                src={logo}
                height="32"
                
                className="d-inline-block align-top"
              />{' '}
            </div>

            <h1 style={{fontSize: '16px', margin: '16px', textAlign: 'left', maxWidth: '300px', whiteSpace: 'pre-wrap', lineHeight:'1em', fontWeight: 700}}>{t("Title")}</h1>


          </Navbar.Brand>
    
          <ToggleLanguage></ToggleLanguage>
        </Container>
      </Navbar>
    </>
  );
}

export default UACTNavbar;
